// src/components/forms/AddQualification.jsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../services/api';
import Loader from '../Utils/Loader';
import '../../css/addQualification.css';

const AddQualification = () => {
  const navigate = useNavigate();
  const [name, setName] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const resetForm = () => {
    setName('');
    setError('');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    setIsSubmitting(true);

    try {
      await api.post('/qualifications', { name });
      setSuccess('Qualifica aggiunta con successo!');
      resetForm();
    } catch (err) {
      console.error("Errore nell'aggiunta della qualifica:", err);
      setError("Errore nell'aggiunta della qualifica");
    } finally {
      setIsSubmitting(false);
    }
  };

  // Durante l'invio mostra loader full-page
  if (isSubmitting) {
    return (
      <div className="addqualification-container">
        <Loader />
      </div>
    );
  }

  return (
    <div className="addqualification-container">
      {error && <p className="error">{error}</p>}
      {success && <p className="success">{success}</p>}

      <h2>Aggiungi Qualifica</h2>
      <form onSubmit={handleSubmit} className="addqualification-form">
        <label>
          Nome della Qualifica:
          <input
            type="text"
            value={name}
            onChange={e => setName(e.target.value)}
            required
            placeholder="Inserisci il nome della qualifica"
            disabled={isSubmitting}
          />
        </label>
        <button type="submit" disabled={isSubmitting}>
          {isSubmitting ? <Loader /> : 'Aggiungi Qualifica'}
        </button>
      </form>

      {success && (
        <button
          onClick={() => navigate('/dashboard')}
          className="redirect-btn"
        >
          Vai alla Dashboard
        </button>
      )}
    </div>
  );
};

export default AddQualification;
